module.exports = __webpack_public_path__ + "img/bg left.068aa876.png";